import { useEffect, useState } from 'react';

const OpenKlaviyoFormButton = ({ formId = 'UYreg6', children }) => {

  const [isKlaviyoReady, setIsKlaviyoReady] = useState(false);

  useEffect(() => {
    // Ensure _klOnsite exists
    window._klOnsite = window._klOnsite || [];

    // Check if Klaviyo is loaded
    const checkKlaviyoReady = setInterval(() => {
      if (window.klaviyo || (window._klOnsite && window._klOnsite.push)) {
        setIsKlaviyoReady(true);
        clearInterval(checkKlaviyoReady);
      }
    }, 100);

    // Cleanup after 10 seconds
    setTimeout(() => clearInterval(checkKlaviyoReady), 10000);

    return () => clearInterval(checkKlaviyoReady);

  }, []);

  const handleClick = () => {
    if (typeof window !== 'undefined') {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }
  };

  const disabledStyles = {
    opacity: 0.5,
    cursor: 'not-allowed',
    filter: 'grayscale(50%)',
  };

  return (
    <button type="button" style={!isKlaviyoReady ? disabledStyles : {}} className="btn-primary-footer btn btn-md btn-block" onClick={handleClick} disabled={!isKlaviyoReady}>
      {children || 'Subscribe'}
    </button>
  );
};

export default OpenKlaviyoFormButton;